import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";

import { IQuickActionsProps, QuickActionOrigin } from "./QuickActions";

export const QuickActionsHeader: React.FC<IQuickActionsProps> = ({
  origin,
  hideHeader,
}) => {
  if (hideHeader) {
    return null;
  }
  if (origin === QuickActionOrigin.SelfServe) {
    return (
      <>
        <Typography variant="subheadingSansMedium">
          <StrictLocalMsg
            defaultMessage="Shortcuts"
            description={{
              text: "Title to a section with shortcuts to all main Faire tasks straight from the self serve flow",
            }}
          />
        </Typography>
        <Spacer height="3x" />
      </>
    );
  }
  return (
    <>
      <Typography variant="pageHeaderSerifRegular">
        <StrictLocalMsg
          defaultMessage="Quick actions"
          description={{
            text: "Title to a section with shortcuts to all main Faire tasks straight from the help center",
          }}
        />
      </Typography>
      <Spacer height="2x" />
    </>
  );
};
